import { formatImageUrl } from '../../lib/imageUrl';
import type { ProductMediaItem, ProductStatus } from '../../types/product';

export const STATUS_LABELS: Record<ProductStatus, string> = {
  draft: 'Черновик',
  active: 'Активный',
  archived: 'Архив',
};

export function formatRelativeRu(iso: string): string {
  const d = new Date(iso).getTime();
  const absDays = Math.floor(Math.abs(Date.now() - d) / 86400000);
  if (absDays === 0) return 'Сегодня';
  if (absDays === 1) return 'Вчера';
  if (absDays < 7) return `${absDays} дн. назад`;
  const absWeeks = Math.floor(absDays / 7);
  if (absWeeks < 5) return `${absWeeks} нед. назад`;
  return new Date(iso).toLocaleString('ru-RU', { dateStyle: 'medium' });
}

export function previewUrlFromProduct(p: { preprocessedImageUrl: string | null; sourceImageUrl: string }): string | null {
  const u = p.preprocessedImageUrl ?? p.sourceImageUrl;
  if (!u || !/^https?:\/\//i.test(u)) return null;
  return formatImageUrl(u);
}

export function fallbackMediaFromProduct(p: {
  id: string;
  name: string;
  sourceImageUrl: string;
  preprocessedImageUrl: string | null;
  createdAt: string;
}): ProductMediaItem[] {
  const u = p.preprocessedImageUrl ?? p.sourceImageUrl;
  if (!u || !/^https?:\/\//i.test(u)) return [];
  return [
    {
      id: `source:${p.id}`,
      kind: 'source',
      origin: 'source',
      url: u,
      thumbnailUrl: null,
      generationId: null,
      generationType: null,
      title: 'Исходное фото',
      isPrimary: true,
      sortOrder: 0,
      createdAt: p.createdAt,
      updatedAt: p.createdAt,
    },
  ];
}

export function mediaCaption(item: ProductMediaItem): string {
  const suffix = item.isPrimary ? ' · главное' : '';
  if (item.kind === 'source') return `Исходная${suffix}`;
  if (item.kind === 'normalized') return `Подготовка${suffix}`;
  return `Готовое фото${suffix}`;
}

export function clientTryOnMessage(productName: string, url: string): string {
  return `Здравствуйте! Вы можете примерить «${productName}» на своём фото здесь: ${url}`;
}

export function confirmTelegram(message: string): Promise<boolean> {
  return new Promise((resolve) => {
    const tg = window.Telegram?.WebApp;
    if (tg?.showConfirm) {
      tg.showConfirm(message, (ok: boolean) => resolve(ok));
    } else {
      resolve(window.confirm(message));
    }
  });
}
